import admin from "../../const/admin";
import netcoServer from '../../apis/netcoServer';
import {DELETE_TIMESTAMP_SERVER} from "../types";
import handleResponse from '../helpers/handleResponse';
import infoPayload from "../helpers/payloadHandlers/infoPayload";
import getAllTimestampServers from './getAllTimestampServers';
import getTimestampsInfo from '../profile/getTimestampsInfo';
import loadingCall from "../helpers/loadingCall";

const deleteTimestampServer= (id) => async (dispatch, getState) => {
  let response = await loadingCall(dispatch, () => netcoServer.newPost('/SystemService/deleteTimestampServer', {id: id}));
  handleResponse(dispatch, response, DELETE_TIMESTAMP_SERVER, data => onSuccessPayload(data, getState), null, [getAllTimestampServers, getTimestampsInfo]);
};

const onSuccessPayload = (data, getState) => {
  return infoPayload('success', admin[getState().auth.language].timestampServerDeleted);
};
export default deleteTimestampServer;